import React, { useState, useMemo } from "react";
import Table from "../pages/ReactTable";
import Loader from "../component/Loader";
import "../css/makeTable.css";

const FileUploadPreview = ({ csvPreview }) => {
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [errorMessage, setErrorMessage] = useState("");

  const hasData = csvPreview.length > 1;
  const totalRecords = hasData ? csvPreview.length - 1 : 0;
  const pageCount = hasData ? Math.ceil(totalRecords / pageSize) : 0;

  // Memoize columns
  const columns = useMemo(() => {
    if (!hasData) return [];
    return csvPreview[0]?.map((header, index) => ({
      Header: header,
      accessor: (row) => row[index] || "",
    }));
  }, [csvPreview]);

  // Paginate preview data
  const paginatedData = useMemo(() => {
    if (!hasData) return [];
    return csvPreview.slice(1).slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
  }, [csvPreview, pageIndex, pageSize]);

  const handleGotoPage = (page) => {
    if (page >= 0 && page < pageCount) {
      setPageIndex(page);
      setErrorMessage("");
    } else {
      setErrorMessage("No data to display");
    }
  };

  if (!hasData) {
    return <p className="errorMessage">No data available</p>;
  }

  return (
    <>
      {isLoadingOn && <Loader />}
      <div className="dashboardTable">
        <Table
          columns={columns}
          data={paginatedData}
          pageCount={pageCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          handleGotoPage={handleGotoPage}
          errorMessage={errorMessage}
        />
      </div>
    </>
  );
};

export default FileUploadPreview;
